<div class="bg-th-yellow mt-0 container-fluid py-2">
  <div class="d-flex justify-content-between align-content-center">
    <i class="fa fa-arrow-left text-secondary my-auto pointer text-dark" [routerLink]="['/']"></i>
    <a class="d-flex align-items-center text-secondary f18 my-auto text-dark">
      <span class="fw-bold"> مدیریت تبلیغات </span>
    </a>
  </div>
</div>

<main class="px-2">
  
  <!-- جدول اطلاعات -->
  <div class="border border-2 container-fluid row gx-0 gx-md-2 gy-2 mt-3 p-2">
    <!-- جستجو -->
    <div class="col-10">
      <input type="text" class="w-100 form-control" placeholder="جستجو کنید ..." (input)="filter_Result($any($event.target).value)"/>
    </div>
    <!-- افزودن -->
    <div class="col-12 col-md-auto position-relative">
      <button class="w-100 btn btn-primary" (click)="openAdd()">
        &nbsp; افزودن &nbsp;
      </button>
    </div>

    <!-- جدول اطلاعات -->
    <div class="section border border-2 mt-2">
      <table class="col-12 table table-striped rounded-3" id="Export_Excel">
        <thead>
          <tr class="text-center">
            <th scope="col" class="">#</th>
            <th scope="col" class="">عملیات</th>
            <th scope="col" class="pointer">تاریخ ثبت</th>
            <th scope="col" class="pointer">تاریخ شروع نمایش</th>
            <th scope="col" class="pointer">تاریخ پایان نمایش</th>
            <th scope="col" class="pointer">عنوان</th>
            <th scope="col" class="pointer">تعداد کلیک</th>
          </tr>
        </thead>

        <tbody>
          <tr class="f14 text-center" *ngFor="let item of lst_Result; let i = index">
            <th class="text-dark">{{ i + 1 | faNum }}</th>
            <th class="">
              <i class="fa fa-edit fa-lg text-dark pointer me-2" (click)="openEdit(item)"></i>
              <i class="fa fa-trash fa-lg text-danger pointer" (click)="delete(item)"></i>
            </th>
            <td dir="ltr">{{ item?.strDate_Save | faNum }}</td>
            <td dir="ltr">{{ item?.strDate_Start | faNum }}</td>
            <td dir="ltr">{{ item?.strDate_End | faNum }}</td>
            <td>{{ item?.strTitle | faNum }}</td>
            <td>{{ item?.iClick | faNum }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- افزودن / ویرایش -->
  <div class="modal fade" id="advertise_Modal" style="z-index: 1054">
    <div class="modal-dialog modal-lg">
      <div class="modal-content dirI">
        <div class="modal-header dirI">
          <h5 class="modal-title">
            {{ editMode ? "ویرایش تبلیغ" : "افزودن تبلیغ" }}
          </h5>

          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>

        <div class="modal-body">
          <div [formGroup]="advForm" class="container-fluid row gx-2 gy-3 p-2">
            <!-- عنوان -->

            <div class="col-12 col-md-6 position-relative">
              <label style="top: -8px"> عنوان </label>

              <input
                formControlName="strTitle"
                class="form-control text-center"
              />
            </div>

            <!-- لینک -->

            <div class="col-12 col-md-6 position-relative">
              <label style="top: -8px"> لینک </label>

              <input
                formControlName="strURL"
                class="form-control text-center"
                dir="ltr"
              />
            </div>

            <!-- تاریخ شروع نمایش -->

            <div class="col-12 col-md-6 position-relative">
              <label style="top: -8px"> تاریخ شروع نمایش </label>

              <ng-persian-datepicker
                [uiTheme]="'gray'"
                [timeEnable]="false"
                [dateGregorianFormat]="'YYYY/MM/DD'"
                [dateInitValue]="true"
                [dateFormat]="'jYYYY/jMM/jDD'"
              >
                <input
                  formControlName="strDate_Start"
                  class="form-control text-end"
                />
              </ng-persian-datepicker>
            </div>

            <!-- تاریخ پایان نمایش -->

            <div class="col-12 col-md-6 position-relative">
              <label style="top: -8px"> تاریخ پایان نمایش </label>

              <ng-persian-datepicker
                [uiTheme]="'gray'"
                [timeEnable]="false"
                [dateGregorianFormat]="'YYYY/MM/DD'"
                [dateInitValue]="true"
                [dateFormat]="'jYYYY/jMM/jDD'"
              >
                <input
                  formControlName="strDate_End"
                  class="form-control text-end"
                />
              </ng-persian-datepicker>
            </div>

            <!-- تصویر -->

            <div class="col-12 position-relative">
              <label style="top: -8px"> تصویر </label>

              <input
                type="file"
                accept=".jpg,.jpeg,.png,image/jpeg,image/png"
                class="form-control"
                [class.border-danger]="submitted && !advForm.get('strImage')?.value"
                (change)="onImageSelected($event)"
              />

              <div class="mt-2" *ngIf="advForm.get('strImage')?.value">
                <img
                  [src]="imagePreview()"
                  style="max-height: 150px; max-width: 100%"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer d-flex justify-content-start">
          <button class="btn btn-success" (click)="submit()">
            ثبت اطلاعات
          </button>

          <button class="btn btn-outline-secondary" data-bs-dismiss="modal">
            &nbsp; بستن &nbsp;
          </button>
        </div>
      </div>
    </div>
  </div>
</main>
